import { render, staticRenderFns } from "./BulkQuizForm.vue?vue&type=template&id=d8d23b5a"
import script from "./BulkQuizForm.vue?vue&type=script&lang=js"
export * from "./BulkQuizForm.vue?vue&type=script&lang=js"
import style0 from "./BulkQuizForm.vue?vue&type=style&index=0&id=d8d23b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports